import React, { } from 'react';
import BaraCautare from '../componente/BaraCautare';
import 'bootstrap/dist/css/bootstrap.min.css';
import './stiluri/Dashboard.css';

const Dashboard = () => {
 

  return (
<div className="container-fluid-dashboard">
<div className="titlu-container">
<h2>Căutare beneficiar</h2>
</div>
      <BaraCautare />
      
    </div>
  );
};

export default Dashboard;
